import React, { Component } from "react";

import ReactTable from "react-table";
import "react-table/react-table.css";
import moment from "moment";
import { Translate, I18n } from "react-redux-i18n";
import { CSVLink } from "react-csv";
import FileDownload from "material-ui/svg-icons/file/file-download";
import Search from "material-ui/svg-icons/action/search";
import { MuiThemeProvider } from "material-ui/styles";
import NumberFormat from "react-number-format";
import { changeActionName } from "./utils";

class TableCommandesLinesHistorique extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      details: "",
      stats: {},
      activeRow: -1
    };
  }

  render() {
    let { data, columns } = this.props;

    let dataArray = [];
    let creationObject = {};
    if (data) {
      Object.keys(data).map(elem => {
        if (data[elem].action == "create") {
          Object.keys(data[elem]).map(property => {
            creationObject[property] = data[elem][property];
            creationObject[data[elem].key_] = data[elem].value;
          });
        } else {
          dataArray.push(data[elem]);
        }
      });
      dataArray.unshift(creationObject);
    }

    let columnsTable = [
      {
        Header: "ID",
        accessor: "id",
        pivot: true,
        filterMethod: (filter, row) =>
          row[filter.id].includes(filter.value) ||
          row[filter.id].toLowerCase().includes(filter.value),
        Filter: ({ filter, onChange }) => (
          <div>
            <MuiThemeProvider>
              <div>
                <Search
                  style={{
                    color: "white",
                    lineHeight: "17.4px",
                    verticalAlign: "middle"
                  }}
                />
                <input
                  onChange={event => onChange(event.target.value)}
                  value={filter ? filter.value : ""}
                  style={{
                    color: "black",
                    backgroundColor: "white",
                    borderRadius: "5px",
                    width: "80%"
                  }}
                />
              </div>
            </MuiThemeProvider>
          </div>
        )
      },
      {
        Header: "Action",
        accessor: "action",
        pivot: true,
        filterMethod: (filter, row) =>
          row[filter.id].includes(filter.value) ||
          row[filter.id].toLowerCase().includes(filter.value)
      },
      {
        Header: "Montant",
        accessor: "price",
        pivot: true,
        Cell: row => (
          <NumberFormat
            style={{ float: "right", marginRight: "15%" }}
            value={row.value}
            displayType={"text"}
            thousandSeparator={" "}
            decimalSeparator={"."}
          />
        )
      },
      {
        Header: "Remise",
        accessor: "discount",
        pivot: true,
        Cell: row => (
          <NumberFormat
            style={{ float: "right", marginRight: "15%" }}
            value={row.value}
            displayType={"text"}
            thousandSeparator={" "}
            decimalSeparator={"."}
          />
        )
      },
      {
        Header: "Offert",
        accessor: "offered",
        pivot: true,
        Cell: row => (
          <NumberFormat
            style={{ float: "right", marginRight: "15%" }}
            value={row.value}
            displayType={"text"}
            thousandSeparator={" "}
            decimalSeparator={"."}
          />
        )
      },
      { Header: "Taux de TVA", accessor: "tax_rate", pivot: true },
      { Header: "Supprimé", accessor: "removed", pivot: true },
      {
        Header: "Ligne parente",
        accessor: "id_order_line_parent",
        pivot: true
      },
      {
        Header: "Commande",
        accessor: "id_order",
        pivot: true,
        filterMethod: (filter, row) =>
          row[filter.id].includes(filter.value) ||
          row[filter.id].toLowerCase().includes(filter.value)
      },
      {
        Header: "Nom",
        accessor: "product_name",
        pivot: true,
        filterMethod: (filter, row) =>
          row[filter.id].includes(filter.value) ||
          row[filter.id].toLowerCase().includes(filter.value)
      },
      {
        Header: "Quantité",
        accessor: "quantity",
        pivot: true,
        Cell: row => (
          <NumberFormat
            style={{ float: "right", marginRight: "15%" }}
            value={row.value}
            displayType={"text"}
            thousandSeparator={" "}
            decimalSeparator={"."}
          />
        )
      },
      {
        Header: "Prix initial",
        accessor: "standardPrice",
        pivot: true,
        Cell: row => (
          <NumberFormat
            style={{ float: "right", marginRight: "15%" }}
            value={row.value}
            displayType={"text"}
            thousandSeparator={" "}
            decimalSeparator={"."}
          />
        )
      },
      {
        Header: "Prix carte",
        accessor: "standardPrice_product",
        pivot: true,
        Cell: row => (
          <NumberFormat
            style={{ float: "right", marginRight: "15%" }}
            value={row.value}
            displayType={"text"}
            thousandSeparator={" "}
            decimalSeparator={"."}
          />
        )
      }
    ];

    let columnsTableExport = [
      { label: "ID", key: "id" },
      { label: "Action", key: "action" },
      { label: "Montant", key: "price" },
      { label: "Remise", key: "discount" },
      { label: "Offert", key: "offered" },
      { label: "Taux de TVA", key: "tax_rate" },
      { label: "Supprimé", key: "removed" },
      { label: "Ligne parente", key: "id_order_line_parent" },
      { label: "Commande", key: "id_order" },
      { label: "Nom", key: "product_name" },
      { label: "Quantité", key: "quantity" },
      { label: "Prix initial", key: "standardPrice" },
      { label: "Prix carte", key: "standardPrice_product" }
    ];

    if (dataArray && dataArray.length > 0) {
      dataArray.forEach(element => {
        if (typeof element != "undefined") {
          element.user_fullname = String(element.lastname + element.firstname);
          element[element.key_] = element.value;
          if (["create", "update", "delete"].includes(element.action)) {
            element.action = changeActionName(element.action);
          }
        }
      });
    }

    return (
      <div>
        <ReactTable
          className=" -highlight -striped"
          style={{ textAlign: "center", maxHeight: "85vh" }}
          data={dataArray}
          defaultPageSize={10}
          filterable
          columns={columnsTable}
          previousText={I18n.t("fisc.table.previousText")}
          nextText={I18n.t("fisc.table.nextText")}
          loadingText={I18n.t("fisc.table.loadingText")}
          noDataText={I18n.t("fisc.table.noDataText")}
          pageText={I18n.t("fisc.table.pageText")}
          ofText={I18n.t("fisc.table.ofText")}
          rowsText={I18n.t("fisc.table.rowsText")}
        />
        {dataArray ? (
          <CSVLink
            style={{ float: "right" }}
            data={dataArray}
            filename="export-lignesCommandesHistorique.csv"
            headers={columnsTableExport}
            separator={";"}
          >
            <MuiThemeProvider>
              <div>
                {" "}
                <button className="btn btn-fisc" style={{ marginRight: "0px" }}>
                  {" "}
                  <FileDownload
                    style={{ lineHeight: "20px", verticalAlign: "middle" }}
                  />{" "}
                  Extraire le tableau{" "}
                </button>{" "}
              </div>
            </MuiThemeProvider>
          </CSVLink>
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default TableCommandesLinesHistorique;
